import { ROUTES } from '../../../constants';

export const BREADCRUMBS_NEWSLETTERS = [
  {
    title: 'Newsletters',
  }
];
